import './index.erb';
import './index.rb';

class VerticalNoticeComponent {
  constructor() {
    setTimeout(() => this.init(), 500);
  }

  init() {
    const topics = {};
    const chapters = {};
    const contents = {};
    const disciplines = {};

    const list = [
      {
        selector: '.discipline-list-item',
        data: disciplines,
        close: [topics, chapters, contents]
      },
      {
        selector: '.topic-list-item',
        data: topics,
        close: [chapters, contents]
      },
      {
        selector: '.chapter-list-item',
        data: chapters,
        close: [contents]
      },
      {
        selector: '.content-list-item',
        data: contents
      }
    ];

    list.forEach(item => this.watch(item));

    $('#back-to-top').on('click', e => {
      e.preventDefault();
      this.backToTop();
    });
  }

  watch({ selector, data, close }) {
    const input = 'input[type="checkbox"]';
    const list = document.querySelectorAll(`${selector} > ${input}`);

    list.forEach(item => {
      $(item).on('change', e => this.change(e, data, close));
    });
  }

  change(e, data, close) {
    data.current = $(e.currentTarget);

    close.forEach(item => this.close(item));

    if (data.previous) {
      const currentId = data.current.prop('id');
      const previousId = data.previous.prop('id');

      if (previousId === currentId) {
        return;
      }

      data.previous.prop('checked', false);
    }

    data.previous = data.current;
  }

  close(data) {
    data.current?.prop('checked', false);
    data.previous?.prop('checked', false);
  }

  backToTop() {
    $('html, body').stop().delay(100).animate({ scrollTop: 0 }, 500, 'swing');
  }
}

(() => {
  new VerticalNoticeComponent();
})();
